import { defineStore } from "pinia"
import moment from 'moment'
import { ref } from 'vue'

export type ItemType = 
| 'photo'
| 'kokuban'
| 'formInputId'
| 'formOptionValue'
| 'camViewer'


export const useItemKeysStore = defineStore('itemKeys', () => {
    // サーバーサイドから取得するキー
    const clientKeyPrefix = ref('')
    // ウィンドウ単位のキー・・・画面を開く毎に初期化する(localStrageから取得する連番を含む)
    const windowId = ref<string | undefined>(undefined)
    // key発行毎の連番(store内でincrement)
    const keySeq = ref(0)


    // 現在時刻のミリ秒の数値を返す
    const currentMillis = () => (Number(moment().format('SSS')));

    // localStrageのキー
    const windowSeqKey = 'KuraemonCloud2-windowSeq'

    // クライアント側で作るキーは36進数(00～zz, 0000～zzzz)表現にする
    const radix = 36;
    const maxWindowSeq = parseInt("zz", radix);
    const maxPhotoKeySeq = parseInt("zzzz", radix);
    const formatKeyNum = (n: Number, padding = 2) => (n.toString(radix).padStart(padding, '0'));


    // ウィンドウ単位のキーを初期化する
    const initWindowId = () => {
      if(windowId.value) return; // 初期化済み

      const cur = localStorage.getItem(windowSeqKey)
      const curWindowSeq = (cur ? Number(cur) : 0) % maxWindowSeq; // ※数値は最大値で循環する
      localStorage.setItem(windowSeqKey, (curWindowSeq + 1).toString()); // increment

      const curMillis = currentMillis(); // ※現在時刻のミリ秒数値を末尾に付与する
      windowId.value = `${ formatKeyNum(curWindowSeq) }${ formatKeyNum(curMillis) }`
    }
    // サーバーサイドから取得するキーを更新する
    const updateClientKeyPrefix = (pramClientKeyPrefix: string) => {
      clientKeyPrefix.value = pramClientKeyPrefix
    }
    // 現在のkeyを返す
    const currentKey = (args: { itemType: ItemType }) => {
      if(!clientKeyPrefix.value) throw new Error("clientKeyPrefixが設定されていない")
      if(!windowId.value) throw new Error("windowIdが設定されていない")
  
      const curKeySeq = keySeq.value % maxPhotoKeySeq; // ※数値は最大値で循環する
      keySeq.value = curKeySeq + 1; // increment

      const curKey = formatKeyNum(curKeySeq, 4)

      const typePrefix = (() => {
        if(args.itemType === 'photo') return 'p1';
        if(args.itemType === 'kokuban') return 'k1';
        if(args.itemType === 'formInputId') return 'input_id_v1';
        if(args.itemType === 'formOptionValue') return 'option_value_v1';
        if(args.itemType === 'camViewer') return 'cam_viewer_v1';
        return '';
      })()

      return `${ typePrefix }_${ clientKeyPrefix.value }_${ windowId.value }${ curKey }`
    }

    const getCurrentKey = (itemType: ItemType) =>{
      return currentKey({ itemType })
    }

    return {
      getCurrentKey,
      currentKey,
      initWindowId,
      updateClientKeyPrefix,
    }
  },
)
